import React from "react";

export default function SectionsPanel({ t, sections, sectionTemplates, onMove, onEdit }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="font-bold text-gray-900">{t("manager.sections.title", "Sections")}</div>
        <div className="text-xs text-gray-500">
          {sections.length} {t("manager.sections.total", "total")}
        </div>
      </div>

      <div className="space-y-3">
        {sections.map((section, index) => {
          const templateData = sectionTemplates?.[section.type]?.[section.template];
          return (
            <div key={section.id} className="border rounded-xl p-3">
              <div className="min-w-0">
                <div className="font-semibold text-gray-900 capitalize">{section.type}</div>
                <div className="text-xs text-gray-500 truncate">{templateData?.name || section.template}</div>
                <div className="text-xs text-gray-400 truncate mt-1">
                  {section.config?.title || t("manager.sections.no-Title", "No title")}
                </div>
              </div>

              <div className="mt-3 flex items-center justify-between gap-2">
                <div className="flex gap-1">
                  <button
                    onClick={() => onMove(index, "up")}
                    disabled={index === 0}
                    className="px-2 py-1 rounded-lg border text-sm disabled:opacity-40 hover:bg-gray-50"
                  >
                     {t("manager.sections.up", "Up")}
                  </button>
                  <button
                    onClick={() => onMove(index, "down")}
                    disabled={index === sections.length - 1}
                    className="px-2 py-1 rounded-lg border text-sm disabled:opacity-40 hover:bg-gray-50"
                  >
                    {t("manager.sections.down", "Down")}
                  </button>
                </div>

                <button
                  onClick={() => onEdit(section)}
                  className="px-3 py-2 rounded-lg bg-blue-50 text-blue-700 text-sm hover:bg-blue-100"
                >
                  {t("manager.edit", "Edit")}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}